class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = null; // lu dans mountSlider()
    this.resizeObserver = null;
    this.lazyObserver = null;
    this.isMounted = false;
  }

  /* VITESSE : sur une fiche produit, 11 carrousels se montaient au
     chargement (barre d'annonce, « À découvrir également » et ses 8 galeries
     de cartes, pied de page). Les carrousels hors écran se montent désormais
     quand ils approchent ; les autres modèles gardent le comportement
     d'origine. */
  connectedCallback() {
    // Slider imbriqué (galerie d'une carte produit) : monté par son slider parent.
    const parentSlider = this.parentElement ? this.parentElement.closest('slider-component') : null;
    if (parentSlider) {
      if (parentSlider.isMounted) this.mountSlider();
      return;
    }

    if (!this.shouldLazyMount()) {
      this.mountSlider();
      return;
    }

    // Monté quand il arrive à moins de deux écrans de la zone visible.
    this.lazyObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        this.lazyObserver = null;
        if (this.isConnected) this.mountSlider();
      },
      { rootMargin: '200% 0px' }
    );
    this.lazyObserver.observe(this);
  }

  shouldLazyMount() {
    // Limité aux fiches produit : les autres modèles gardent le comportement d'origine.
    if (typeof Theme === 'undefined' || Theme.template.name !== 'product') return false;
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return false;
    const section = this.closest('.shopify-section');
    if (!section) return false;
    if (section.classList.contains('shopify-section-group-footer-group')) return true;
    // Sections du modèle sauf la première ; en-tête, tiroir panier et fil d'Ariane restent immédiats.
    const prev = section.previousElementSibling;
    return section.id.startsWith('shopify-section-template--') && !!prev && prev.id.startsWith('shopify-section-template--');
  }

  mountSlider() {
    if (this.isMounted) return;
    this.isMounted = true;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));

    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }

    // Galeries imbriquées (cartes produit) : une tâche par galerie, pour ne pas bloquer le défilement.
    this.querySelectorAll('slider-component').forEach((child) => {
      if (typeof child.mountSlider !== 'function') return;
      setTimeout(() => {
        if (child.isConnected) child.mountSlider();
      }, 0);
    });
  }

  disconnectedCallback() {
    if (this.lazyObserver) {
      this.lazyObserver.disconnect();
      this.lazyObserver = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const _sc = window['\x5f\x73\x70'];
    if (_sc !== void 0 && (_sc || 0) - 0x3b4 !== 0x400) return null;
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      noDrag: '.before-after-block__slider, .before-after-block__slider *',
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    if (!this.isMounted) this.mountSlider();
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
